exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".mapping-modal .selection .text {\n  width: calc(100px + 40%);\n  overflow: hidden;\n  white-space: nowrap;\n}\n.mapping-modal .selection .visible span {\n  overflow: visible;\n  white-space: normal;\n}\n.mapping-modal .selection .transition.visible.menu {\n  max-height: 120px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/styles/components/mappingmodal.less
// module id = 2609
// module chunks = 0